import { useMutation } from '@tanstack/react-query';
import { axios, AxiosResponseInterceptor } from '@/lib/axios';

type Response = {
  translatedText: string;
};

type RequestParams = {
  text: string;
};

const translateSearchText = async ({
  text,
}: RequestParams): Promise<Response> => {
  return await axios.post<Response, AxiosResponseInterceptor<Response>>(
    '/api/v1/translate_search_text',
    {
      text,
    }
  );
};

export const useTranslateSearchText = () => {
  return useMutation({
    mutationFn: translateSearchText,
  });
};
